import { IoIosArrowBack, IoIosArrowDown } from "react-icons/io";
import { Link, NavLink } from "react-router-dom";
import style from "./NavbarWide.module.css";
import useSharedData from "../../../../../hooks/useSharedData";

function NavbarWide() {
  const { hasAccess, isAuthed } = useSharedData();

  return (
    <nav className={"d-none d-xl-flex align-items-center " + style.nav}>
      <Link to="/" className="w-auto h-auto">
        <img src="../logoTemp.png" className={style.logo} />
      </Link>
      <ul className={"d-flex me-xxl-3 " + style.items}>
        <li>
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive === true ? style.borderActive : ""
            }
          >
            صفحه‌ی اصلی
          </NavLink>
        </li>
        <li>
          <NavLink className="d-flex column-gap-1">
            <span>ثبت سفارش</span>
            <span>
              <IoIosArrowDown />
            </span>
          </NavLink>
          <ul>
            <li>
              <div className="d-flex justify-content-between color-avaex">
                <span>سفارش داخلی</span>
                <span>
                  <IoIosArrowBack />
                </span>
              </div>
              <ul>
                <li>
                  <Link to="/new/letter">آنلاین (پیشکرایه)</Link>
                </li>
                <li>
                  <Link to="/new/cod">پسکرایه (COD)</Link>
                </li>
                <li>
                  <Link to="/new/bulk">سفارش انبوه</Link>
                </li>

                {hasAccess(1) && (
                  <li>
                    <Link to="/shop">سفارش آوا شاپ</Link>
                  </li>
                )}

                {hasAccess(10) && (
                  <li>
                    <Link to="/vip">سفارش ویژه</Link>
                  </li>
                )}

                <li>
                  <Link to="/avabox">سفارش آوا باکس</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/newex">
                <span>سفارش خارجی</span>
              </Link>
            </li>
          </ul>
        </li>

        <li>
          <NavLink
            to="/tracking"
            className={({ isActive }) =>
              isActive === true ? style.borderActive : ""
            }
          >
            رهگیری مرسوله
          </NavLink>
        </li>

        <li>
          <div className="d-flex justify-content-between color-avaex">
            <NavLink
              to="/developers"
              className={({ isActive }) =>
                isActive === true ? style.borderActive : ""
              }
            >
              توسعه دهندگان
            </NavLink>
            <span className="me-1">
              <IoIosArrowDown />
            </span>
          </div>

          <ul>
            <li>
              <Link to="/developers/web-service">وب سرویس (API)</Link>
            </li>
            <li>
              <Link to="/developers/plugin">پلاگین وردپرسی</Link>
            </li>
            <li>
              <Link to="/developers/php-package">پکیج PHP</Link>
            </li>
            <li>
              <Link to="/developers/digi-extension">اکستنشن دیجی کالا</Link>
            </li>
          </ul>
        </li>

        {isAuthed && (
          <li>
            <NavLink className={"d-flex column-gap-1"}>
              <span>حساب من</span>
              <span>
                <IoIosArrowDown />
              </span>
            </NavLink>
            <ul>
              <li>
                <Link to="/account">پروفایل</Link>
              </li>
              <li>
                <Link to="/prewallet">کیف پول</Link>
              </li>
              <li>
                <Link to="/myletters">مرسولات من</Link>
              </li>
              <li>
                <Link to="/my-external-letters">مرسولات خارجی من</Link>
              </li>
            </ul>
          </li>
        )}

        <li>
          <NavLink
            to="/preagent"
            className={({ isActive }) =>
              isActive === true ? style.borderActive : ""
            }
          >
            اخذ نمایندگی
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/support"
            className={({ isActive }) =>
              isActive === true ? style.borderActive : ""
            }
          >
            پشتیبانی
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/contact"
            className={({ isActive }) =>
              isActive === true ? style.borderActive : ""
            }
          >
            تماس با ما
          </NavLink>
        </li>
      </ul>
    </nav>
  );
}

export default NavbarWide;
